// extracted by mini-css-extract-plugin
export default {"ring":"ProgressRing_ring__y6E6R","svg":"ProgressRing_svg__QcX1c","label":"ProgressRing_label__OU13n"};